






























































































import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat, isDecimal } from '@/utils/common'
import { MensagensDaApiEnum } from '@/types/_'
import _ from 'lodash'

@Component
export default class ComponentModalAlterarPontuacaoProfissional extends Vue {
  loadAlterarPontuacaoProfissional: boolean = false
  loadingPontuacaoProfissional: boolean = false
  $refs!: { formAlterarPontuacao: any }

  formAlterarPontuacaoRules: any = {
    valid: true,
    profissionalPontuacao: [(v: string) => !!v || 'Campo obrigatório'],
    pontuacaoProfissional: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get loadingAlterarPontuacaoProfissional() { return this.loadAlterarPontuacaoProfissional }
  set loadingAlterarPontuacaoProfissional(value: boolean) { this.loadAlterarPontuacaoProfissional = value }

  get modalAlterarPontuacaoProfissional() { return this.getFinanceiroStore.modal.modalAlterarPontuacaoProfissional }
  set modalAlterarPontuacaoProfissional(value: boolean) { this.getFinanceiroStore.setModal({ name: 'modalAlterarPontuacaoProfissional', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get profissionaisExecutantes() {
    return this.getFinanceiroStore.profissionaisExecutantes
  }

  set profissionaisExecutantes(value: any) {
    this.getFinanceiroStore.profissionaisExecutantes = value
  }

  get profissionalPontuacao() {
    return this.getFinanceiroStore.profissionalPontuacao
  }

  set profissionalPontuacao(value: string) {
    this.getFinanceiroStore.setProfissionalPontuacao(value)
  }

  get pontuacaoProfissional() {
    return this.getFinanceiroStore.pontuacaoProfissional
  }

  set pontuacaoProfissional(value: string) {
    this.getFinanceiroStore.setPontuacaoProfissional(value)
  }

  getPontuacaoText(item) {
    return `Nome: ${item.nome} - Cód.: ${item.codigoPontuacao}`
  }

  get filtroCodigoPontuacaoOuNome() { return this.getFinanceiroStore.filtroCodigoPontuacaoOuNome }

  set filtroCodigoPontuacaoOuNome(value: any) { this.getFinanceiroStore.setFiltroCodigoPontuacaoOuNome(value) }

  debounce = _.debounce(() => this.getFinanceiroStore.getAllItemsSenioridade(), 300)

  async saveAlterarPontuacaoProfissional() {
    if (this.$refs.formAlterarPontuacao.validate()) {
      this.loadingAlterarPontuacaoProfissional = true
      const response = await this.getFinanceiroStore.saveAlterarPontuacaoProfissional()
      if (response.success) {
        this.modalAlterarPontuacaoProfissional = false
        EventBus.$emit('setSnackbar', { show: true, text: 'Pontuação profissional alterada com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao salvar!', icon: 'warning', color: '#C62828' })
      }
      this.loadingAlterarPontuacaoProfissional = false
    }
  }

  @Watch('modalAlterarPontuacaoProfissional')
  onModalAlterarPontuacaoProfissionalChanged(value: boolean) {
    if (!value) {
      this.$nextTick(() => {
        this.pontuacaoProfissional = ''
        this.profissionalPontuacao = ''
        this.filtroCodigoPontuacaoOuNome = ''
        this.$refs.formAlterarPontuacao.resetValidation()
      })
    } else {
      if(this.getFinanceiroStore.profissionalPontuacao){
        const profissionalObj = {
          userId: this.getFinanceiroStore.profissionalPontuacao,
          nome: this.getFinanceiroStore.profissionalPontuacaoNome
        }

        this.getFinanceiroStore.setProfissionaisExecutantes([profissionalObj])
      }
    }
    
    this.getFinanceiroStore.setItemsSenioridade([])
  }

  async onSearchPontuacao(val: any | Event){
    if(val){
      val = val.target.value
      
      if(val.length < 2){
        this.filtroCodigoPontuacaoOuNome = ''
        return
      }

      this.loadingPontuacaoProfissional = true
      this.filtroCodigoPontuacaoOuNome = val
      await this.debounce()
      this.loadingPontuacaoProfissional = false
    }else {
      this.filtroCodigoPontuacaoOuNome = ''
    }
  }
}
